import React from 'react'
import { observable, action } from 'mobx'
import { observer } from 'mobx-react'
import NavigationManagerContext from './contexts/NavigationManagerContext'

class NavigationManager extends React.Component {

  steps = [
    'step_1',
    'step_2',
    'step_3',
    'step_4',
    'step_5',
  ]

  _currentStep = observable.box(0)

  get currentStep () {
    return this._currentStep.get()
  }

  componentDidMount () {
    const urlSlug = this.props.settings.getOtherSettings('page_settings_slug', 'port-config')

    const urlParts = window.location.pathname.match(new RegExp(urlSlug.replace('/', '\\/') + '\/([0-9]+)'))

    const step = parseInt(urlParts !== null && urlParts[1] > 0 ? urlParts[1] - 1 : 0)

    this.setStep(step, 'replace')

    window.onpopstate = (e) => {
      if (typeof e.state.step != 'undefined') {
        e.preventDefault()
        this.setStep(e.state.step, false)
      }
    }
  }

  getStepName (step_index) {
    if (step_index < 0 || step_index >= this.steps.length) return false
    return this.steps[step_index]
  }

  @action
  setStep (value, history_type = 'push') {
    if (value < 0) value = 0
    if (value >= this.steps.length) value = this.steps.length - 1

    const urlSlug = this.props.settings.getOtherSettings('page_settings_slug', 'port-config')

    let new_url = window.location.href.replace(new RegExp('(' + urlSlug.replace('/', '\\/') + ')\/?([0-9]+)?'), '$1/' + (value + 1))

    if (history_type === 'push') {
      let step_settings = this.props.settings.getStepSettings(this.steps[value])
      history.pushState({ step: value }, step_settings.title, new_url)
      if (typeof ga === 'function') {
        ga('send', 'pageview', {
          page: window.location.pathname,
          title: step_settings.title
        })
      }
    } else if (history_type === 'replace') {
      let step_settings = this.props.settings.getStepSettings(this.steps[value])
      history.replaceState({ step: value }, step_settings.title, new_url)
    }

    this._currentStep.set(value)
  }

  nextStep () {
    window.scrollTo(0, 0)
    this.setStep(this._currentStep.get() + 1)
  }

  prevStep () {
    window.scrollTo(0, 0)
    this.setStep(this._currentStep.get() - 1)
  }

  render () {
    return (
      <NavigationManagerContext.Provider value={this}>
        <React.Fragment>
          {this.props.children}
        </React.Fragment>
      </NavigationManagerContext.Provider>
    )
  }
}

export default observer(NavigationManager)